import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign "ResizeObserver loop" warnings (triggered by Radix UI / iframe
// CSEN resize) — they don't affect functionality and only show the noisy
// red dev-server error overlay in CRA preview.
const _resizeObserverErrRe = /ResizeObserver loop/;
const _origError = window.console.error;
window.console.error = (...args) => {
  if (args && args[0] && typeof args[0] === "string" && _resizeObserverErrRe.test(args[0])) return;
  _origError(...args);
};
window.addEventListener("error", (e) => {
  if (e && e.message && _resizeObserverErrRe.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
